<template>
  <div
    class="template-usage-toggle"
  >
    <v-btn
      variant="outlined"
      min-width="48"
      width="48"
      class="toggle-icon"
      :active="currentTab === 'template-usage'"
      @click="setCurrentTab('template-usage')"
    >
      <v-icon
        icon="$multicast"
        size="22"
      />
    </v-btn>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useDocumentRightPanel } from '@/stores/document/rightPanel';

const rightPanelStore = useDocumentRightPanel();
const { currentTab } = storeToRefs(rightPanelStore);
const { setCurrentTab } = rightPanelStore;
</script>

<style lang="less" scoped>
.toggle-icon {
  border-color: @stroke-default;

  .v-icon {
    color: @icon-default;
  }
}
</style>
